import { Grid, Paper } from '@mui/material'
import React from 'react'
import { isISODateString } from '../services'
import moment from 'moment'

const Header2 = (props) => {

    const { commonStyle, data: headerData, companyHeading = true, rows = {} } = props
    const { heading = {}, typography = {} } = commonStyle

    const companyName = headerData?.headerData?.companyName ?? "N/A"

    return (
        <>
            <Grid
                container
                component={Paper}
            >
                {
                    headerData?.headerFields?.map((field) => {
                        return (
                            <>
                                <Grid
                                    item
                                    xs={6}
                                    sx={{ ...heading }}
                                >
                                    {field?.name}
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                    sx={{ ...typography }}
                                >
                                    {
                                        field?.uniqueName === "companyName"
                                            ? companyName
                                            : isISODateString(rows[field?.uniqueName])
                                                ? moment(rows[field?.uniqueName]).format("DD/MM/YYYY")
                                                : rows[field?.uniqueName]

                                                ?? "N/A"
                                    }
                                </Grid>
                            </>
                        )
                    })
                }

            </Grid>
        </>
    )
}

export default Header2
